import React, { useContext } from 'react';
import { Stack, Overlay, Spinner } from 'office-ui-fabric-react';
import { AppThemeContext } from '../contexts/AppThemeContext';

const Loader = (props) => {
    const { theme } = useContext(AppThemeContext);

    return (
        <Overlay style={{ backgroundColor: theme.palette.white, opacity: '.95' }}>
            <Stack horizontalAlign='center' verticalAlign='center' verticalFill>
                <Spinner label="درحال بارگذاری اطلاعات..." />
            </Stack>
        </Overlay>
    );
}

export default Loader;